import * as classNames from 'classnames/bind'
import * as React from 'react'

import { ISubMenuItem, ITopMenuItem } from '../../../config/sites/menus/types'
import CategoryLink from './categoryLink'

import * as styles from './categoriesMenu.module.css'

const TopLevelMenu = ({ menuItem }: { menuItem: ITopMenuItem }) => {
  const cx = classNames.bind(styles)
  const hasChildren = menuItem.children.length > 0
  const isNew = menuItem.isNew
  const linkClassName = cx(styles.link, {
    link: hasChildren,
    linkEmpty: !hasChildren,
    'header-categories__main-link--new-label': hasChildren && isNew
  })

  return (
    <li className={styles.menuItem} aria-haspopup="true">
      <CategoryLink
        to={menuItem.url}
        isInternal={menuItem.isInternal}
        className={linkClassName}
      >
        {menuItem.name + ' '}
        {isNew && <span className={styles.label}>New</span>}
      </CategoryLink>
      {hasChildren && <SubLevelMenu menuItems={menuItem.children} />}
    </li>
  )
}

const SubLevelMenu = ({ menuItems }: { menuItems: ISubMenuItem[] }) => {
  const cx = classNames.bind(styles)

  return (
    <div className={styles.dropdownContainer}>
      <ul className={styles.dropdown}>
        {menuItems.map((menuItem, key) => {
          const isTop = menuItem.isTop
          const isBottom = menuItem.isBottom
          const linkClassName = cx(
            { dropdownTop: isTop },
            { dropdownBottom: isBottom }
          )
          return (
            <li className={linkClassName} key={key}>
              <CategoryLink to={menuItem.url} isInternal={menuItem.isInternal}>
                {menuItem.name + ' '}
              </CategoryLink>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

const CategoriesMenu = ({ menuConfig }: { menuConfig: ITopMenuItem[] }) => {
  return (
    <ul className={styles.linksList} data-test-selector="category-menu">
      {menuConfig.map((menuItem, key) => {
        return <TopLevelMenu key={key} menuItem={menuItem} />
      })}
    </ul>
  )
}

export default CategoriesMenu
